import { stripePublicKey } from '../../constants/stripePublicKey';

export const getInitialStripeUrl = () => {
    if (stripePublicKey.startsWith('pk_test_')) {
        return 'https://dashboard.stripe.com/test';
    } else {
        return 'https://dashboard.stripe.com';
    }
};
